<template>
    <div class="index-wrap">
        <van-nav-bar
            title="确认订单"
            left-arrow
            @click-left="$router.back();"
        ></van-nav-bar>
        <view-body></view-body>
    </div>
</template>
<script>
import ViewBody from './ViewBody';
export default {
    components: {
        ViewBody
    }
};
</script>
<style lang="scss" scoped>
.index-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.van-nav-bar .van-icon {
    color: #000000;
}
.van-nav-bar__title {
    color: #000000;
    font-size: 18px;
    font-weight: bold;
}
</style>